export default "__VITE_ASSET__CN3F4eNl__"